export const getAbsoluteUrl = (path: string | undefined | null): string => {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    const domain = apiBase.replace(/\/api$/, '');
    return `${domain}${path}`;
};
